function CtaSection() {
  return (
    <section className="rounded-[2rem] bg-brand-deep px-7 py-10 text-white shadow-bloom sm:px-10">
      <p className="text-xs font-semibold uppercase tracking-[0.24em] text-white/80">Ready for your next appointment?</p>
      <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <h2 className="max-w-2xl text-4xl leading-tight sm:text-5xl">
          Let us create a look that feels effortless and elevated.
        </h2>
        <a
          href="tel:+17175257477"
          className="rounded-full border border-brand-primary/35 bg-white px-4 py-2 text-sm font-semibold text-brand-deep transition hover:bg-brand-mist"
        >
          (717) 525-7477
        </a>
      </div>
    </section>
  );
}

export default CtaSection;